// src/pages/MyDeals.jsx
import React, { useEffect, useState } from "react";
import api from "../api";
import * as XLSX from "xlsx";
import { generateDealPDF } from "./../../utils/generateDealPDF";
import { useNavigate } from "react-router-dom";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";


const MyDeals = () => {
  const [deals, setDeals] = useState([]);
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const [search, setSearch] = useState("");
  const [showReceipt, setShowReceipt] = useState(false);
const [receiptUrl, setReceiptUrl] = useState("");
const [selectedDeal, setSelectedDeal] = useState(null);


  useEffect(() => {
    const fetchDeals = async () => {
      try {
        const res = await api.get("/my-deals");
        setDeals(res.data);
      } catch (err) {
        console.error("Error fetching deals:", err);
      }
    };
    fetchDeals();
  }, []);

  // 🔍 Filter by buyer or seller
  const filteredDeals = deals.filter((deal) => {
    const query = search.toLowerCase();
    return (
      deal.buyer.toLowerCase().includes(query) ||
      deal.seller.toLowerCase().includes(query)
    );
  });

  // 📄 Pagination based on FILTERED data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentDeals = filteredDeals.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const totalPages = Math.ceil(filteredDeals.length / itemsPerPage);

//   const exportToExcel = () => {
//   const dataForExcel = deals.map((deal) => {
//     const bales = parseInt(deal.bales) || 0;
//     const dalali = parseInt(deal.dalali) || 0;
//     const amount = bales * dalali;

//     return {
//       "Sauda Date": formatDate(deal.date),
//       Buyer: deal.buyer,
//       Seller: deal.seller,
//       Station: deal.station,
//       Bales: bales,
//       Brokerage: dalali,
//       Amount: amount,
//       "Candy Rate": deal.candy_rate,
//     };
//   });

//   const worksheet = XLSX.utils.json_to_sheet(dataForExcel);

//   // ❌ Removed S.No column width
//   worksheet["!cols"] = [
//     { wch: 15 },  // Sauda Date
//     { wch: 20 },  // Buyer
//     { wch: 20 },  // Seller
//     { wch: 15 },  // Station
//     { wch: 10 },  // Bales
//     { wch: 10 },  // Brokerage
//     { wch: 15 },  // Amount
//     { wch: 15 },  // Candy Rate
//   ];

//   // ✅ Apply bold header + borders
//   const range = XLSX.utils.decode_range(worksheet["!ref"]);

//   for (let R = range.s.r; R <= range.e.r; ++R) {
//     for (let C = range.s.c; C <= range.e.c; ++C) {
//       const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });

//       if (!worksheet[cellAddress]) continue;

//       // Initialize style
//       worksheet[cellAddress].s = {
//         font: {
//           bold: R === 0, // ✅ First row bold
//         },
//         border: {
//           top: { style: "thin" },
//           bottom: { style: "thin" },
//           left: { style: "thin" },
//           right: { style: "thin" },
//         },
//       };
//     }
//   }

//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "My Deals");

//   const today = new Date().toISOString().split("T")[0];
//   XLSX.writeFile(workbook, `MyDeals_${today}.xlsx`);
// };


const exportToExcel = async () => {

  // ✅ Sort by date (ascending)
  const sortedDeals = [...deals].sort(
    (a, b) => new Date(a.date) - new Date(b.date)
  );

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("My Deals");

  worksheet.mergeCells("A1:H1");
const titleCell = worksheet.getCell("A1");

titleCell.value = "SHIV TRADE LINK COTTON BROKERAGE SESSION 2025-26";
titleCell.font = { bold: true, size: 14 };
titleCell.alignment = { horizontal: "center", vertical: "middle" };

// ✅ Empty row (optional spacing)
worksheet.addRow([]);

  // ✅ Header
  const header = [
    "Sauda Date",
    "Buyer",
    "Seller",
    "Station",
    "Bales",
    "Brokerage",
    "Amount",
    "Candy Rate",
  ];

  worksheet.addRow(header);

  // ✅ Data
  sortedDeals.forEach((deal) => {
    const bales = parseInt(deal.bales) || 0;
    const dalali = parseInt(deal.dalali) || 0;

    worksheet.addRow([
      formatDate(deal.date),
      deal.buyer,
      deal.seller,
      deal.station,
      bales,
      dalali,
      bales * dalali,
      deal.candy_rate,
    ]);
  });

  // ✅ Bold Header + Center + Border
  worksheet.getRow(3).eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // ✅ Apply border to all cells
  worksheet.eachRow((row) => {
    row.eachCell((cell) => {
      cell.border = {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      };
    });
  });

  // ✅ Column Width
  worksheet.columns = [
    { width: 15 },
    { width: 30 },
    { width: 30},
    { width: 15 },
    { width: 10 },
    { width: 12 },
    { width: 15 },
    { width: 15 },
  ];

  // ✅ Download file
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(
    new Blob([buffer]),
    `MyDeals_${new Date().toISOString().split("T")[0]}.xlsx`
  );
};

 const handleEdit = (deal) => {
  navigate(`/edit-deal/${deal.id}`);
};
 const handleView = async (deal) => {
  const pdfUrl = await generateDealPDF(deal, false); // ❌ no auto-download
  if (pdfUrl) {
    setReceiptUrl(pdfUrl);
    setSelectedDeal(deal);
    setShowReceipt(true);
  }
};

const handleDelete = async (id) => {
  const confirmDelete = window.confirm("Are you sure you want to delete this deal?");
  if (!confirmDelete) return;


  console.log("🗑️ Deleting deal with ID:", id);

  try {
    await api.delete(`/deleteDeal/${id}`);
    alert("✅ Deal deleted successfully");

    // Remove deleted deal from UI
    setDeals((prevDeals) => prevDeals.filter((deal) => deal.id !== id));
  } catch (error) {
    console.error("❌ Delete error:", error);
    alert("❌ Failed to delete deal");
  }
};




  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>📑 My Deals</h2>
        <button className="btn btn-success" onClick={exportToExcel}>
          ⬇️ Download Excel
        </button>
      </div>

      {/* 🔍 Search Input */}
      <div className="mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Search Buyer or Seller..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1);
          }}
        />
      </div>

      {filteredDeals.length === 0 ? (
        <p>No deals found.</p>
      ) : (
        <>
          <table className="table table-bordered table-striped table-hover">
            <thead className="table-dark">
              <tr>
                <th>S.no</th>
                <th>Sauda Date</th>
                <th>Buyer</th>
                <th>Seller</th>
                <th>Station</th>
                <th>Bales</th>
                <th>Dalali</th>
                <th>Amount</th>
                <th>Candy Rate</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {currentDeals.map((deal, index) => {
                const bales = parseInt(deal.bales) || 0;
                const dalali = parseInt(deal.dalali) || 0;
                const amount = bales * dalali;

                return (
                  <tr key={deal.id}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{formatDate(deal.date)}</td>
                    <td>{deal.buyer}</td>
                    <td>{deal.seller}</td>
                    <td>{deal.station}</td>
                    <td>{bales}</td>
                    <td>{dalali}</td>
                    <td>{amount}</td>
                    <td>{deal.candy_rate}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-primary me-2"
                        onClick={() => handleEdit(deal)}
                      >
                        Edit
                      </button>
                      <button
                        className="btn btn-sm btn-info"
                        onClick={() => handleView(deal)}
                      >
                        View
                      </button>
                       <button
    className="btn btn-sm btn-danger"
    onClick={() => handleDelete(deal.id)}
  >
    Delete
  </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          {/* Pagination */}
          <div className="d-flex justify-content-center mt-3">
            <nav>
              <ul className="pagination">
                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => setCurrentPage(currentPage - 1)}
                  >
                    Previous
                  </button>
                </li>

                {[...Array(totalPages)].map((_, i) => (
                  <li
                    key={i}
                    className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage(i + 1)}
                    >
                      {i + 1}
                    </button>
                  </li>
                ))}

                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => setCurrentPage(currentPage + 1)}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </>
      )}

      {/* 📄 Receipt Modal */}
{showReceipt && (
  <div className="modal fade show d-block" tabIndex="-1">
    <div className="modal-dialog modal-lg modal-dialog-centered modal-fullscreen-sm-down">
      <div className="modal-content">

        <div className="modal-header">
          <h5 className="modal-title">Deal Receipt</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowReceipt(false)}
          ></button>
        </div>

        <div className="modal-body p-0" style={{ height: "70vh" }}>
          <iframe
            src={receiptUrl}
            title="Deal Receipt"
            style={{
              width: "100%",
              height: "100%",
              border: "none",
            }}
          />
        </div>

        <div className="modal-footer">
          {/* ✅ Mobile-safe download */}
          <a
            href={receiptUrl}
            download={`deal_${selectedDeal?.id}.pdf`}
            className="btn btn-success"
          >
            Download
          </a>

          <button
            className="btn btn-secondary"
            onClick={() => setShowReceipt(false)}
          >
            Close
          </button>
        </div>

      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default MyDeals;
